import { useState } from 'react'
import { Box, Button, Flex, Text } from '@chakra-ui/react'
import { UserSection } from './UserSection'
import { DeleteUserDialog } from './DeleteUserDialog'
import { useTranslation } from '../../i18n'

function Action({ title, help, onClick, disabled }) {
    return (
        <Flex gap={4} align="center" wrap="wrap">
            <Box flex="1" minW="220px">
                <Text fontSize="sm" color="var(--mc-text-muted)">{help}</Text>
            </Box>
            <Button size="sm" variant="outline" colorPalette="red" onClick={onClick} disabled={disabled}>
                {title}
            </Button>
        </Flex>
    )
}

// Remove access / delete account. When the server would refuse (yourself, the
// last sysadmin, open sales leads) the reason it gives is shown instead of
// buttons that would fail.
export function DangerZoneCard({ user, onDone }) {
    const { t } = useTranslation()
    const [kind, setKind] = useState(null)
    const refusal = user.deleteRefusal

    return (
        <UserSection id="user-danger" title={t('users.danger.title')} tone="danger">
            {refusal && <Text fontSize="sm" color="var(--mc-text)" role="note">{refusal}</Text>}
            <Action
                title={t('users.danger.removeAccess')}
                help={t('users.danger.removeAccessHelp')}
                disabled={!!refusal}
                onClick={() => setKind('access')}
            />
            <Action
                title={t('users.danger.delete')}
                help={t('users.danger.deleteHelp')}
                disabled={!!refusal}
                onClick={() => setKind('delete')}
            />
            {kind && (
                <DeleteUserDialog
                    key={kind}
                    user={user}
                    kind={kind}
                    onClose={() => setKind(null)}
                    onDone={(mode) => {
                        setKind(null)
                        onDone(mode)
                    }}
                />
            )}
        </UserSection>
    )
}
